import SectionHead from "@/components/SectionHead";
import {
  Globe, Store, BookOpen, Magnet, CalendarCheck, MapPin, MessageCircle, Wrench,
} from "lucide-react";
import { useLang } from "@/i18n";

const ICONS = [Globe, Store, BookOpen, Magnet, CalendarCheck, MapPin, MessageCircle, Wrench];

const Services = () => {
  const t = useLang().t;
  return (
  <section id="services" data-testid="services" className="bg-[#F5F2EB] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="services-head"
        eyebrow={t.services.eyebrow}
        title={t.services.title}
        sub={t.services.sub}
      />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {t.services.items.map((s, i) => {
          const Icon = ICONS[i];
          return (
          <div key={s.title} data-testid={`service-${i}`} className="card-site p-6">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#F5F2EB]">
              <Icon className="h-5 w-5 text-[#A88667]" />
            </div>
            <h3 className="mt-4 font-heading text-base sm:text-lg font-bold text-[#3E2723]">{s.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-[#5D4037]">{s.desc}</p>
          </div>
          );
        })}
      </div>
    </div>
  </section>
  );
};

export default Services;
